<template>
    <div style="margin-bottom: 14em;">
        <div class="headlin-text" style="padding-bottom: 4%;">Forgot Password?</div>
        <div>
            <div class="input-area">
                <div class="input-field-area">
                    <div>Enter your username or email below</div>
                    <input class="input-filed" type="text" placeholder="eg. myemail@myemail.com" v-model="email">
                </div>
            </div>
            <div style="padding-top: 3%">
                <button class="adway-btn-class" @click="makeRequest">
                    <span class="btn__text__bold">Submit</span>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import HTTPRequest from './../../plugins/utils/HttpRequest.js'
// import Config from './../../plugins/utils/Config.js'
import toast from '@utils/toast.js'
export default {
  name: 'ForgotPassword',
  data: function () {
    return {
      email: ''
      // config: Config
    }
  },
  methods: {
    makeRequest () {
      var request = new HTTPRequest()
      var url = '/user/password/reset'
      var body = {
        user: this.email,
        API_KEY: ''
      }
      request.makeRequest('POST', url, body).then((response) => {
        var jsonResponse = JSON.parse(response)
        if (jsonResponse.code === 0) {
          toast.successMessage('Check your email')
          this.$emit('confirm')
        } else {
          toast.errorMessage(jsonResponse.message)
        }
      }).catch((error) => {
        console.log("Error", error)
        toast.errorMessage(error)
      })
    }
  }
}
</script>
